import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import cn from 'classnames'
import { isEmpty } from 'lodash'

import useInterval from '../hooks/useInterval'
import { getCurrentMenuId, getPerformSafeUpdate } from '../selectors/appState'
import { getActiveAttendantId, getAttendants } from '../selectors/attendant'
import { menusItemsRequested } from '../actions/menus'
import ConcessionsCartSidebar from '../containers/ConcessionsCartSidebar'
import CartModal from '../containers/CartModal'
import Items from '../containers/Items'
import Navbar from '../containers/Navbar'
import CategoryBar from '../containers/CategoryBar'

import HeaderBar from '../components/HeaderBar'

import styles from './Main.module.scss'
import { getCarouselImages } from '../actions/carouselImages';
import { clearRemoteOrderTotal } from '../actions/orderTotalRemote'
import { fetchPromotions } from '../actions/promotion'
import { clearOrderInProgress } from '../actions/order'
import { refreshCache } from '../utils/newAppVersionAvailable'

const Main = ({
  className,
  currentMenuUuid,
  menusItemsRequested,
  getCarouselImages,
  clearOrderInProgress,
  clearTotal,
  fetchPromotions,
  attendantsExist,
  hasActiveAttendant,
  redirectToLogin,
  performSafeUpdate,
}) => {
  const classNames = cn(styles.main, className)

  useEffect(() => {
    if (performSafeUpdate) {
      refreshCache()
    }
    menusItemsRequested()
    getCarouselImages()
    clearTotal()
    fetchPromotions()
    clearOrderInProgress()
  }, [])

  useEffect(() => {
    if (attendantsExist && !hasActiveAttendant) {
      redirectToLogin()
    }
  }, [hasActiveAttendant])

  useInterval(() => {
    if (currentMenuUuid && localStorage.getItem('accessToken')) menusItemsRequested()
  }, 600000)

  const cart = document?.body?.clientWidth <= 800 ? <CartModal /> : <ConcessionsCartSidebar className={styles.sidebar} />

  return (
    <div className={classNames}>
      <HeaderBar />
      <Navbar className={styles.navbar} />
      {cart}
      <div className={styles.content}>
        <CategoryBar />
        <Items />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const currentMenuUuid = getCurrentMenuId(state)
  const attendantsExist = !isEmpty(getAttendants(state))
  const hasActiveAttendant = getActiveAttendantId(state) !== undefined
  const performSafeUpdate = getPerformSafeUpdate(state)

  return {
    currentMenuUuid,
    attendantsExist,
    hasActiveAttendant,
    performSafeUpdate,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const replace = props?.history?.replace ?? (() => {})

  return {
    getCarouselImages: () => dispatch(getCarouselImages()),
    menusItemsRequested: () => dispatch(menusItemsRequested()),
    clearTotal: () => dispatch(clearRemoteOrderTotal()),
    fetchPromotions: () => dispatch(fetchPromotions()),
    redirectToLogin: () => {
      replace('/user-login')
    },
    clearOrderInProgress: () => dispatch(clearOrderInProgress()),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main))
